export enum WorkoutExecutionType {
    INDOOR = 'INDOOR',
    OUTDOOR = 'OUTDOOR',
}
